export const PROXY_SERVER = 'http://videoadmin.bannerch.org.tw'
